export default "__VITE_ASSET__fe91d98e__"